var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.098 46.0715C120.379 55.3085 121.824 65.6075 120.252 75.6662C118.68 85.7248 114.16 95.0913 107.264 102.581C100.369 110.071 91.407 115.348 81.5123 117.745C71.6177 120.142 61.2345 119.55 51.6758 116.046C42.1171 112.542 33.8123 106.282 27.8114 98.0575C21.8105 89.8332 18.3832 80.0142 17.9627 69.8421C17.5423 59.67 20.1477 49.6016 25.4494 40.9102C30.7511 32.2188 38.511 25.2947 47.7479 21.0135C53.881 18.1699 60.5142 16.5624 67.2686 16.2828C74.0231 16.0032 80.7664 17.0569 87.1135 19.3839C93.4607 21.7108 99.2872 25.2654 104.26 29.8445C109.234 34.4236 113.256 39.9376 116.098 46.0715Z",
    fill: "#FF886F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3238 74.058C34.8323 69.4065 33.2303 64.9413 30.6527 61.0384C28.075 57.1354 24.5972 53.909 20.5122 51.6309C16.4075 64.0269 17.1863 77.5219 22.6899 89.3633C24.0171 92.2288 25.6017 94.9679 27.4242 97.5469C30.3804 94.4488 32.62 90.7393 33.985 86.6805C35.35 82.6218 35.807 78.3128 35.3238 74.058Z",
    fill: "#F4F4F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3072 107.354C67.1184 108.165 60.5395 111.778 55.999 117.411C67.6661 120.58 80.078 119.521 91.0396 114.421C92.0609 113.948 93.0686 113.441 94.0222 112.906C88.412 108.583 81.349 106.594 74.3072 107.354Z",
    fill: "#F4F4F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7527 16.4821C72.3594 16.3401 70.973 16.2657 69.5865 16.2454C62.0473 16.198 54.5906 17.8145 47.7478 20.9797C45.7069 21.9324 43.7301 23.0168 41.83 24.2261C47.2716 26.5852 53.335 27.102 59.0975 25.6981C64.8599 24.2941 70.006 21.0461 73.7527 16.4483V16.4821Z",
    fill: "#F4F4F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.536 60.4367C109.424 66.115 108.608 71.929 106.19 77.143C103.773 82.3571 99.8628 86.7369 94.9553 89.7281C90.0478 92.7194 84.3633 94.1876 78.6211 93.9472C72.8789 93.7067 67.3371 91.7682 62.6969 88.3771C58.0568 84.986 54.5268 80.2946 52.5538 74.8967C50.5807 69.4987 50.2532 63.6368 51.6128 58.0527C52.9723 52.4686 55.9578 47.4132 60.1914 43.5264C64.425 39.6396 69.7164 37.0959 75.3961 36.2174C79.1627 35.6294 83.0082 35.7895 86.7128 36.6887C90.4174 37.588 93.9084 39.2086 96.9863 41.4579C100.064 43.7072 102.668 46.5412 104.65 49.7977C106.632 53.0543 107.953 56.6695 108.536 60.4367Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.856 78.9005L83.6676 80.0705L79.7246 63.1623L79.1362 60.3759L78.5275 57.3188C77.7362 58.5362 77.1748 59.3478 76.857 59.7469L74.1517 63.0812L70.3033 59.9227L77.9797 50.6503L83.0589 49.6831L89.8831 78.8802L89.856 78.9005Z",
    fill: "#E26954"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M99.1014 108.213C77.2155 124.444 49.9527 124.701 38.2319 108.842C26.5111 92.9816 34.6879 66.9565 56.5739 50.7246C78.4599 34.4927 105.729 34.2357 117.443 50.0957C129.158 65.9556 120.994 91.9807 99.1014 108.213Z",
    fill: "url(#paint0_radial_87_623)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.459,
    width: 82.5121,
    height: 85.2174,
    fill: "url(#pattern0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.6715,
    y: 79.8068,
    width: 77.1014,
    height: 60.1932,
    fill: "url(#pattern1)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6.08696,
    width: 66.9565,
    height: 73.7198,
    fill: "url(#pattern2)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M32.6454 36.4135C32.2734 39.4773 39.686 38.5304 49.2019 34.2966C58.7178 30.0628 66.7323 24.1517 67.0975 21.0879C67.4628 18.0241 60.057 18.971 50.541 23.2048C41.0251 27.4386 33.0173 33.3497 32.6454 36.4135Z",
    fill: "url(#paint1_radial_87_623)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M66.8541 56.3594C73.1816 41.2478 67.6388 24.5288 54.4738 19.0163C41.3089 13.5039 25.5072 21.2856 19.1796 36.3972C12.8521 51.5088 18.3949 68.2278 31.5599 73.7403C44.7248 79.2527 60.5266 71.471 66.8541 56.3594Z",
    fill: "url(#paint2_radial_87_623)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M66.2048 30.7594C62.2821 31.4357 59.5227 34.7498 60.0435 38.199C60.5642 41.6483 64.1623 43.8734 68.085 43.2039C72.0077 42.5343 74.7739 39.2135 74.2531 35.7643C73.7323 32.315 70.1275 30.0898 66.2048 30.7594Z",
    fill: "url(#paint3_radial_87_623)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_87_623",
    transform: "scale(0.00819672 0.00793651)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_87_623",
    transform: "scale(0.00877193 0.011236)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_87_623",
    transform: "scale(0.010101 0.00917431)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_87_623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.3888 81.3089) rotate(53.4475) scale(35.6032 49.3104)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9BA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#9B9BA3",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#9B9BA3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_87_623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.531 26.2321) rotate(156.067) scale(18.8083 4.75749)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "white",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_87_623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.2313 45.2758) rotate(-152.85) scale(25.8733 29.6627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_87_623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.5199 31.2811) rotate(-98.4711) scale(6.29585 7.20853)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_87_623",
    width: 122,
    height: 126,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_87_623",
    width: 114,
    height: 89,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHIAAABZCAYAAADitnCIAAAACXBIWXMAAAsSAAALEgHS3X78AAAEAklEQVR4Xu2c208TURCHv61UNDRKvOM1UTRK4pvxRf9+HzTRBxPjPfGKeIsQUKFofZid9Ox2C0TQnp38vqQ5wPbGfnvmzMxpWgwGA0T76Wx3B9EOJDIIEhkEiQyCRAZBIoMgkUGQyCBIZBAkMggSGQSJDIJEBkEigyCRQZDIIEhkECQyCBIZBIkMgkQGQSKDIJFBkMggSGQQJDIIEhkEiQyCRAZBIoMgkUGQyCBMbXeHzClqozOojeFpg8hxsgqgC+wvRz8+APrARjmOkxlKds4iCyz0TwHTVGVR/n4IOFGO/r9sAivAx3LsM0qT7FaLzVGkC+wCM8AR4BRDWS5zGjgJXCrH6fLv68AS8KIc16kyoCp7GZPZJLY1UnMT6QJ7wFHgPHAZuEpVVoG993RGdstjfaozcpNRIXXZa5jQj8A34Gd52wR+Nzw+O4qMvtWjAxzExFwErgDXMZHnqMqC3a2RqexlTOQS8Bx4D3wCFoGv5bE+mQvNRWSBCTkN3ABuAQvABWxmzjC6Rvrj0tHZbr2ry+5jQpeAz8Bb4DHwDHgNfCFzoTmF1mngDHATuI1J7GECO4zK2opxglM62Gv6WjiLrcU/sfC6gIl8SFXoKkOh2ZCLSA+Th4GzwFz5c5rc7DV12R0sKvSw1z7GcI12oU+Bl1hI/kFGMnMRCcMExkuNffw7iU0UVKV61uxJ1zzwCLgD3MPW0g0yCbM5ifSyYJ1htjipFmKBXUj1MuhoefwLlix9A341PcH/JheRnnwsA++w0NXDTuCkZEJVqJ+rBeAJtmaukknyM8mTVGcdk3gfeIBljmvYFT/pE+VCe1iYvYolRl7XTpzcZuQnTGTabpvj77PXvaSpCeHJ2KQvtGxEgoWoH9hMhGEb7RrN9WSanPwPBrVbVuQkEiyMuswNrEB/TLXDMwscoNpI30nd+LcMsIusj62Ji9gSsExz+28i5CYSTOZ3hifrDVbHec/1LFbjncTqvS7NrTpnp5KbukEe8tewTPUVVoLcxd5fvSE/MXJp0TVRMJr+zwHHsVbePCZzBhNab577c2wl2RnXn/WerF9M2TYFchbpuNApLKQewMLrCUzgDM3bWU3JSSo5ZdyOie+S1Puu2bXp2iDSSROcdJZ5a6+eScL4Pcs6TXuY3qBYAT6Q+U5Im0SmpOveVuGzS3O5kJIKq3+qwENu2m3K8oS1VWSdcQnNbtdIP5aOWRJF5FbsJmttDTmWH3tNqwXtlJx6rWIXSGQQJDIIEhkEiQyCRAZBIoMgkUGQyCBIZBAkMggSGQSJDIJEBkEigyCRQZDIIEhkECQyCBIZBIkMgkQGQSKDIJFBkMggSGQQJDIIEhkEiQyCRAZBIoMgkUH4A/cKIO8+9htIAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_87_623",
    width: 99,
    height: 109,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.b7385721141524afa42923c4f56f9916.svg";
export { ForwardRef as ReactComponent };